/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2020. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';

// Models
import { IBankAccount, ICard } from '@core/models';

export const loadPaymentMethods = createAction(
  '[ClientDetails:PaymentMethods] Load Payment Methods ',
  props<{ clientId: number }>()
);
export const loadPaymentMethodsSuccess = createAction(
  '[ClientDetails:PaymentMethods] Load Payment Methods Success',
  props<{ data: (IBankAccount & ICard)[] }>()
);
export const loadPaymentMethodsFailure = createAction(
  '[ClientDetails:PaymentMethods] Load Payment Methods Failure',
  props<{ errorMessage: string }>()
);
export const removePaymentMethod = createAction(
  '[ClientDetails:PaymentMethods] Remove Payment Method',
  props<{ paymentMethodId: string }>()
);

export const addBankAccount = createAction(
  '[ClientDetails:PaymentMethods] Add Bank Account',
  props<{ stripeCustomerId: string; bankAccount: any }>()
);
export const addBankAccountSuccess = createAction(
  '[ClientDetails:PaymentMethods] Add Bank Account Success',
  props<{ bankAccount: any }>()
);
export const addBankAccountFailure = createAction(
  '[ClientDetails:PaymentMethods] Add Bank Account Failure',
  props<{ errorMessage: string }>()
);
